import { render, staticRenderFns } from "./PrivateContentReduced.vue?vue&type=template&id=07d83cc9&"
import script from "./PrivateContentReduced.vue?vue&type=script&lang=js&"
export * from "./PrivateContentReduced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports